import RenderHTML from "../../../../components/ui-components/RenderHTML"

type StepHeadingProps = {
  stepNumber: number
  title: string
}

export function StepHeading({ stepNumber, title }: StepHeadingProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-[13px] font-[400] text-[#6A6E6E]">Step {stepNumber}</span>
      <span className={'text-[18px] font-[500] text-[#232323] leading-[130%]'}> <RenderHTML innerHTMLText={title} /> </span>
    </div>
  )
}
